module.exports = __webpack_public_path__ + "static/media/asthma.972a5e65.png";